import React, { useState } from 'react'

import { useIsOwner } from 'redux/hooks/Groups'
import { useIsMobile, useParams } from 'utils/hooks'

import Button from 'components_new/atoms/Button'

import GroupContent from 'components_new/organisms/GroupContent'
import GroupHeader from 'components_new/organisms/GroupHeader'

import GroupTemplate from 'components_new/templates/GroupTemplate'
import { useTranslation } from 'language/translator'
import { useCustomer } from 'redux/hooks/Customer'

const Group = () => {
  const { id } = useParams<{ id: string }>()
  const isMobile = useIsMobile()
  const isOwner = useIsOwner(id)
  const customer = useCustomer()
  const { t } = useTranslation()

  const [editMode, setEditMode] = useState<boolean>(false)

  return (
    <GroupTemplate
      topbar={
        isOwner && !isMobile && customer?.allow_access.allow_key_metrics
          ? {
              actions: (
                <Button
                  onClick={() => setEditMode(!editMode)}
                  variant={editMode ? 'contained' : 'text'}
                >
                  {editMode ? t('global', 'done') : t('global', 'edit')}
                </Button>
              )
            }
          : undefined
      }
    >
      <GroupHeader
        sx={{
          ...(editMode
            ? {
                cursor: 'not-allowed',
                opacity: 0.5,
                pointerEvents: 'none'
              }
            : null),
          mb: 6
        }}
      />
      <GroupContent editMode={editMode} setEditMode={setEditMode} />
    </GroupTemplate>
  )
}

export default Group
